export const supportTicketPopupSelector = '.order-item-more-info.support-ticket';

export function findSupportTicketPopup(scope) {
    return $(scope).closest(supportTicketPopupSelector);
}
